import { MDBAnimation, MDBCard, MDBCardBody, MDBCardImage, MDBCardText, MDBCol, MDBContainer, MDBIcon, MDBPagination, MDBPaginationItem, MDBPaginationLink, MDBRipple, MDBRow } from "mdb-react-ui-kit"
import { useEffect, useState, createContext } from "react"
import { Link, Outlet } from 'react-router'

interface newsModel {
    img: string
    heading: string
    date: string
    body?: Array<string>
    links?: Array<string>
}

const newsDb: Array<newsModel> = [
    {
        img: '../../../../Yilo_Krobo_Municipal_Assembly_Inaugurates_Abrewankor_Community_Seed_Bank/1.jpeg',
        heading: 'Yilo Krobo Municipal Assembly inaugurates Abrewankor Community Seed Bank to boost agriculture',
        date: 'January 25, 2026',
        links: [
            'https://3news.com/news/yilo-krobo-municipal-assembly-inaugurates-abrewankor-community-seed-bank-to-boost-agriculture',
            'https://onuaonline.com/yilo-krobo-municipal-assembly-inaugurates-abrewankor-community-seed-bank-to-boost-agriculture/',
            'https://mobile.ghanaweb.com/GhanaHomePage/regional/Abrewankor-inaugurates-Ghana-s-second-community-seed-bank-2019102'
        ]
    },
    {
        img: '../../../../Community_Seed_Bank_Capacity_Building_Workshop_in_Yilo_Krobo_Municipality/1.jpeg',
        heading: 'Community Seed Bank Capacity-Building Workshop in Yilo Krobo Municipality',
        date: 'January 09, 2026',
        body: [
            "Community Seed Bank Capacity-Building Workshop in Yilo Krobo Municipality Last Friday, NUS Network Ghana organized a capacity-building workshop for farmers from the Abrewankor and Nkurakan operational areas in the Yilo Krobo Municipality.",
            "The session focused on the establishment and long-term sustainability of Community Seed Banks as a key approach to conserving local crop diversity and strengthening resilient seed systems.",
            "The workshop recorded strong participation and enthusiasm from farmers, who demonstrated their commitment by bringing their own saved seeds for inclusion in the community seed bank.",
            "This active engagement reflects growing local ownership of the initiative and highlights the readiness of the communities to sustainably manage their seed resources.",
            "The activity represents an important milestone toward the commissioning of the Abrewankor Community Seed Bank, scheduled to take place in the coming weeks.",
            "A key takeaway from the training was the importance of proper seed handling and storage, captured in the guiding principle:'Keep it dry, keep it safe.'",
            "Through such initiatives, NUS Network Ghana continues to support farmer-led seed systems that promote agro-biodiversity, food security, and climate resilience."
        ]
    }
    ,
    {
        img: '../../../../Training_of_farmers_stakeholders_and_executive_committee_members_on_conservation_of_root_and_tuber_of_Community_Seed_Banks/1.jpeg',
        heading: 'Training of farmers, stakeholders and executive committee members on conservation of root and tuber of Community Seed Banks',
        date: 'January 01, 2026',
        body: [
            "Today’s workshop brought together stakeholders, farmers, and Executive Committee members of the Abrewankor Community Seed Bank for an in-depth discussion on root and tuber conservation.",
            "Participants explored the purpose of conserving root and tuber crops, identified key challenges, and jointly brainstormed practical mitigation strategies.",
            "The session was held at MacDic Royal Plaza Hotel, Koforidua, and was organized and facilitated by NUS Network Ghana.",
            "Strengthening community seed systems for food security and resilience."
        ]
    }
    
]

interface newsContext {

    news: Array<Array<newsModel>> | undefined
    newsList: Array<newsModel> | undefined
    pageHandler: (index: number) => void
    index: number | undefined
    pager: Array<Array<number>> | undefined
    pagerList: Array<number> | undefined
    pagerIndex: number | undefined

    pageBack: () => void

    pageForward: () => void

}

export const NewsContext = createContext<newsContext | undefined>(undefined)


export const News = () => {

    let st: number = 0

    let en: number = 9

    let totalPages: number = Math.ceil(newsDb.length / en)

    let news: Array<Array<newsModel>> = []

    const [news_, setNews_] = useState<Array<Array<newsModel>> | undefined>(news)

    let newsList: Array<newsModel> = []

    const [newsList_, setNewsList_] = useState<Array<newsModel> | undefined>(newsList)

    const [index, setIndex] = useState<number | undefined>(0)

    useEffect(() => {

        Array.from({ length: totalPages }).map(
            (_, index) => {
                let n = newsDb.slice(st, en)

                news.push(n)

                st = st + 9
                en = en + 9

            }
        )

        setNews_(news)

        return () => {

            news = []

        }

    }, [newsDb])



    useEffect(() => {

        if (news_ === undefined) {
            return
        }

        if (index === undefined) {
            return
        }

        let newsList__ = news_[index]

        setNewsList_(newsList__)

        return () => {

            newsList__ = []
        }

    }, [index])


    const pagingHandler = (index: number) => {

        setIndex(index)

    }

    // pager
    const pager: Array<Array<number>> = []

    const [pager_, setPager_] = useState<Array<Array<number>> | undefined>(pager)

    useEffect(() => {

        // pagingList
        const pagingList: Array<number> = []

        if (news_ === undefined) {
            return
        }

        Array.from({ length: news_.length }).map(
            (_, index) => {
                pagingList.push(index + 1)
            }
        )

        const pagerLength: number = Math.ceil(pagingList.length / 9)

        let st_ = 0

        let en_ = 9

        Array.from({ length: pagerLength }).map(
            (_, val) => {

                let n = pagingList.slice(st_, en_)

                pager.push(n)

                st_ = st_ + 9

                en_ = en_ + 9
            }
        )

        setPager_(pager)

    }, [news_])

    const [pagerIndex, setPagerIndex] = useState<number | undefined>(0)

    const pagerList: Array<number> = []

    const [pagerList_, setPagerList_] = useState<Array<number> | undefined>(pagerList)

    useEffect(() => {

        if (pager_ === undefined) {
            return
        }

        if (pagerIndex === undefined) {
            return
        }

        const n = pager_[pagerIndex]

        setPagerList_(n)

    }, [pagerIndex])

    // pagerBack
    const pagerBack = () => {

        if (pagerIndex === undefined) {
            return
        }

        setPagerIndex(pagerIndex - 1)

    }

    // pagerForward
    const pagerForward = () => {

        if (pagerIndex === undefined) {
            return
        }

        setPagerIndex(pagerIndex + 1)
    }

    return (
        <>
            <NewsContext.Provider value={{ news: news_, newsList: newsList_, pageHandler: pagingHandler, index: index, pager: pager_, pagerList: pagerList_, pagerIndex: pagerIndex, pageBack: pagerBack, pageForward: pagerForward }}>
                <Outlet />
            </NewsContext.Provider>
        </>
    )
}